import { parseEntityItemId } from '@wix/a11y-rules';
import { bulkUpdateExperiences } from '@wix/ambassador-table-reservations-v1-experience/http';
import { chunk as getChunks } from 'lodash';
import { fetchTableReservationsExperiences } from '../new-infra-fetchers/fetch-table-reservations-experiences';
import { buildTableReservationsExperiencesBulkUpdatePayload } from './build-payloads/bulk-update-table-reservations-experiences-alt-text-payload-builder';
// BulkUpdateExperiences has a maxSize of 100 per request.
const BULK_LIMIT = 100;
const getExperienceIdForItem = item => {
  if (item.entityId) {
    return item.entityId;
  }
  const {
    entities
  } = parseEntityItemId(item.id, 2);
  return entities[0] ?? item.id;
};
export const updateTableReservationsExperiencesAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const experienceIds = [...new Set(altTextData.map(getExperienceIdForItem).filter(id => id !== undefined))];
  try {
    const experiences = await fetchTableReservationsExperiences(httpClient, errorHandler, experienceIds);
    const experiencesMap = new Map(experiences.map(experience => [experience.id, experience]));
    const maskedExperiences = buildTableReservationsExperiencesBulkUpdatePayload(altTextData, experiencesMap);
    const succeededExperienceIds = new Set();
    const chunks = getChunks(maskedExperiences, BULK_LIMIT);
    for (const chunk of chunks) {
      try {
        const response = await withErrorHandler(async () => httpClient.request(bulkUpdateExperiences({
          experiences: chunk
        })), {
          errorCodesMap: {}
        });
        (response.data.results ?? []).forEach(result => {
          var _result$itemMetadata;
          if ((_result$itemMetadata = result.itemMetadata) != null && _result$itemMetadata.success && result.itemMetadata.id) {
            succeededExperienceIds.add(result.itemMetadata.id);
          }
        });
      } catch (_error) {}
    }
    const allFailedElements = altTextData.filter(item => {
      const experienceId = getExperienceIdForItem(item);
      return !experienceId || !succeededExperienceIds.has(experienceId);
    });
    const overallSuccess = allFailedElements.length === 0;
    return {
      errorMessage: overallSuccess ? undefined : `Failed to update alt text for ${allFailedElements.length} item(s)`,
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-table-reservations-experiences-alt-text.js.map